import { defineComponent as ie, mergeModels as K, computed as h, useModel as de, ref as b, watch as L, createElementBlock as D, openBlock as k, normalizeClass as Y, createElementVNode as M, Fragment as U, renderList as x, toDisplayString as A, createVNode as H, withCtx as J, createTextVNode as W, nextTick as ve } from "vue";
import { D as _, I as Z } from "./luxon-BFLqgYPH.js";
import { _ as Q } from "./Button.ce.vue_vue_type_script_setup_true_lang-3QjuPmOY.js";
import { _ as fe } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const me = ["aria-label"], ye = {
  class: "arbo-calendar-header",
  role: "row"
}, Se = { class: "arbo-calendar-weeks" }, pe = ["aria-label", "data-date", "data-weekday", "tabindex", "onClick"], he = { class: "arbo-calendar-actions" }, _e = /* @__PURE__ */ ie({
  __name: "MainCalendar",
  props: /* @__PURE__ */ K({
    year: {},
    month: {},
    startDate: {},
    endDate: {},
    timezone: { default: "UTC" },
    activeField: { default: "start" },
    requireConfirm: { type: Boolean, default: !1 },
    locale: { default: "en-US" },
    weekdayLabelStyle: { default: "narrow" },
    weekStart: { default: 0 },
    cancelLabel: { default: "Cancel" },
    confirmLabel: { default: "Confirm" }
  }, {
    tracingCase: {
      default: () => ({ case: "", behavior: "" })
    },
    tracingCaseModifiers: {}
  }),
  emits: /* @__PURE__ */ K(["select-start", "select-end", "select-start-utc", "select-end-utc", "update:activeField", "update:tracingCase", "update:month", "update:year", "close", "confirm", "cancel"], ["update:tracingCase"]),
  setup(G, { emit: X }) {
    const t = G, ee = h(() => t.startDate && t.endDate), te = de(G, "tracingCase"), c = X, i = b(t.year), u = b(t.month);
    L(
      () => [t.year, t.month],
      ([e, l]) => {
        i.value = e, u.value = l;
      }
    );
    const ae = h(
      () => _.fromObject({ year: i.value, month: u.value, day: 1 }, { zone: t.timezone }).setLocale(t.locale || "en-US").toFormat("LLLL yyyy")
    ), I = h(() => _.now().setZone(t.timezone)), v = h(
      () => t.startDate ? _.fromJSDate(t.startDate, { zone: t.timezone }) : null
    ), f = h(() => t.endDate ? _.fromJSDate(t.endDate, { zone: t.timezone }) : null), C = b(v.value), O = b(f.value), $ = b(v.value), z = b(f.value);
    L(
      [v, f],
      () => {
        t.requireConfirm || (C.value = v.value, O.value = f.value, $.value = v.value, z.value = f.value);
      },
      { immediate: !0 }
    );
    const d = h(() => t.requireConfirm ? C.value : v.value), S = h(() => t.requireConfirm ? O.value : f.value);
    L(
      () => t.activeField,
      (e) => {
        const l = e === "start" ? d.value : S.value;
        l && (i.value = l.year, u.value = l.month);
      }
    ), L(
      () => [d.value?.toISODate(), S.value?.toISODate(), t.activeField],
      () => {
        const e = t.activeField === "start" ? d.value : S.value;
        e && (e.year !== i.value || e.month !== u.value) && (i.value = e.year, u.value = e.month);
      }
    );
    function le(e) {
      return e.setZone("utc");
    }
    const y = b("");
    function P(e) {
      y.value = e.toISODate() || "", ve(() => {
        document.querySelector(`.arbo-calendar-day[data-date="${y.value}"]`)?.focus();
      });
    }
    L(
      () => [
        i.value,
        u.value,
        t.activeField,
        d.value?.toISODate(),
        S.value?.toISODate()
      ],
      () => {
        const e = t.activeField === "start" ? d.value : S.value;
        let l;
        e && e.year === i.value && e.month === u.value ? l = e : d.value && d.value.year === i.value && d.value.month === u.value ? l = d.value : l = I.value, P(l);
      }
    );
    function ne(e) {
      return e.toFormat("d");
    }
    const B = h(() => {
      const e = _.fromObject(
        { year: i.value, month: u.value, day: 1 },
        { zone: t.timezone }
      ), l = e.weekday, a = t.weekStart === 1 ? (l + 6) % 7 : l % 7;
      let n = e.minus({ days: a });
      const r = [], m = Z.weekdays(t.weekdayLabelStyle || "short", {
        locale: t.locale || "en-US"
      });
      for (let o = 0; o < 42; o++) {
        const p = [];
        n.month !== u.value && p.push("is-outside"), n.hasSame(I.value, "day") && p.push("is-today"), d.value && n.hasSame(d.value, "day") && p.push("is-selected-start"), S.value && n.hasSame(S.value, "day") && p.push("is-selected-end"), d.value && S.value && n > d.value && n < S.value && p.push("is-in-range");
        const g = ne(n), w = m[n.weekday - 1] || "";
        r.push({
          dt: n,
          iso: n.toISODate() || "",
          label: n.toFormat("d"),
          displayLabel: g,
          weekdayLabel: w,
          aria: n.setLocale(t.locale || "en-US").toFormat("cccc, d LLLL yyyy"),
          classes: p
        }), n = n.plus({ days: 1 });
      }
      const s = [];
      for (let o = 0; o < 6; o++) s.push(r.slice(o * 7, o * 7 + 7));
      return s;
    }), oe = h(() => {
      const e = Z.weekdays(t.weekdayLabelStyle || "short", {
        locale: t.locale || "en-US"
      });
      return t.weekStart === 1 ? e : [e[6], ...e.slice(0, 6)];
    });
    function R(e, l, a) {
      const n = e === "start" ? l.startOf("day") : l.endOf("day"), r = le(n), m = {
        year: n.year,
        month: n.month,
        day: n.day,
        utc: r.toISO() || ""
      };
      e === "start" ? (c("select-start", m, a ?? !0), c("select-start-utc", m.utc)) : (c("select-end", m), c("select-end-utc", m.utc));
    }
    function q(e) {
      let l = i.value, a = u.value + e;
      for (; a < 1; )
        a += 12, l -= 1;
      for (; a > 12; )
        a -= 12, l += 1;
      i.value = l, u.value = a, c("update:year", l), c("update:month", a);
    }
    function T(e) {
      const a = (y.value ? _.fromISO(y.value, { zone: t.timezone }) : I.value).plus({ days: e });
      (a.month !== u.value || a.year !== i.value) && (u.value = a.month, i.value = a.year, c("update:year", a.year), c("update:month", a.month)), P(a);
    }
    function V(e = !1) {
      const a = (y.value ? _.fromISO(y.value, { zone: t.timezone }) : I.value).weekday % 7, n = e ? 6 - a : -a;
      T(n);
    }
    function re(e) {
      switch (e.key) {
        case "ArrowLeft":
          e.preventDefault(), T(-1);
          break;
        case "ArrowRight":
          e.preventDefault(), T(1);
          break;
        case "ArrowUp":
          e.preventDefault(), T(-7);
          break;
        case "ArrowDown":
          e.preventDefault(), T(7);
          break;
        case "Home":
          e.preventDefault(), V(!1);
          break;
        case "End":
          e.preventDefault(), V(!0);
          break;
        case "PageUp":
          e.preventDefault(), q(e.shiftKey ? -12 : -1);
          break;
        case "PageDown":
          e.preventDefault(), q(e.shiftKey ? 12 : 1);
          break;
        case "Enter":
        case " ": {
          e.preventDefault();
          const l = y.value ? _.fromISO(y.value, { zone: t.timezone }) : I.value, a = B.value.flat().find((n) => n.iso === l.toISODate());
          a && j(a);
          break;
        }
      }
    }
    function j(e) {
      const l = !!v.value, a = !!f.value, n = t.activeField, r = v.value?.toISODate() || "null", m = f.value?.toISODate() || "null", s = e.dt.toISODate() || "", o = (E, ce) => {
        te.value = { case: E, behavior: ce };
      }, p = () => `Selected start ${s} > existing end ${m} -> reset both to ${s}`, g = () => `Selected end ${s} < existing start ${r} -> reset both to ${s}`, w = () => {
        R("start", e.dt, !0), R("end", e.dt), c("update:activeField", "end");
      }, F = (E = !1) => {
        R("start", e.dt, E), E && c("update:activeField", "end");
      }, N = (E = !1) => {
        R("end", e.dt), E && c("close");
      };
      if (l && a) {
        n === "start" ? f.value && e.dt > f.value ? (w(), o("INVERT_RANGE_FROM_START", p())) : (F(!1), o(
          "UPDATE_START_IN_RANGE",
          `Updated start from ${r} to ${s}; end remains ${m}`
        )) : v.value && e.dt < v.value ? (w(), o("INVERT_RANGE_FROM_END", g())) : (N(!1), o(
          "UPDATE_END_IN_RANGE",
          `Updated end from ${m} to ${s}; start remains ${r}`
        ));
        return;
      }
      if (!l && a && n === "start" && f.value && e.dt > f.value) {
        w(), o("CREATE_RANGE_FROM_LATE_START", p());
        return;
      }
      if (l && !a && n === "end" && v.value && e.dt < v.value) {
        w(), o("CREATE_RANGE_FROM_EARLY_END", g());
        return;
      }
      if (!l && !a) {
        if (n === "start") {
          F(!0), o("INIT_START", `Picked start ${s}; awaiting end selection`);
          return;
        }
        N(!0), o("INIT_END", `Picked end ${s}; awaiting start selection`);
        return;
      }
      if (!l && a) {
        if (n === "start") {
          F(!0), o("FILL_MISSING_START", `Inserted start ${s}; existing end ${m}`);
          return;
        }
        N(!1), o("STRICT_UPDATE_END_ONLY", `Updated end to ${s}; start still null`);
        return;
      }
      if (l && !a) {
        if (n === "start") {
          F(!0), o("RESELECT_START_BEFORE_END", `Replaced start with ${s}; end still null, switching to end`);
          return;
        }
        N(!0), o("FILL_MISSING_END", `Picked end ${s}; start ${r}`);
        return;
      }
    }
    function se() {
      $.value = C.value, z.value = O.value, c("confirm");
    }
    function ue() {
      C.value = $.value, O.value = z.value, c("cancel");
    }
    return (e, l) => (k(), D("div", {
      class: Y(["arbo-calendar", { "full-date": ee.value }]),
      role: "grid",
      "aria-label": ae.value,
      tabindex: "0",
      onKeydown: re
    }, [
      M("div", ye, [
        (k(!0), D(U, null, x(oe.value, (a) => (k(), D("div", {
          key: a,
          class: "arbo-calendar-weekday",
          role: "columnheader"
        }, A(a), 1))), 128))
      ]),
      M("div", Se, [
        (k(!0), D(U, null, x(B.value, (a, n) => (k(), D("div", {
          key: n,
          class: "arbo-calendar-week",
          role: "row"
        }, [
          (k(!0), D(U, null, x(a, (r) => (k(), D("div", {
            key: r.iso,
            class: Y(["arbo-calendar-day", [r.classes, { "is-focused": r.iso === y.value }]]),
            role: "gridcell",
            "aria-label": r.aria,
            "data-date": r.iso,
            "data-weekday": r.weekdayLabel,
            tabindex: r.iso === y.value ? 0 : -1,
            onClick: (m) => j(r)
          }, A(r.displayLabel), 11, pe))), 128))
        ]))), 128))
      ]),
      M("div", he, [
        H(Q, {
          type: "secondary",
          size: "small",
          onClick: ue
        }, {
          default: J(() => [
            W(A(t.cancelLabel), 1)
          ]),
          _: 1
        }),
        H(Q, {
          type: "primary",
          size: "small",
          onClick: se
        }, {
          default: J(() => [
            W(A(t.confirmLabel), 1)
          ]),
          _: 1
        })
      ])
    ], 42, me));
  }
}), Ee = /* @__PURE__ */ fe(_e, [["__scopeId", "data-v-5a528316"]]);
export {
  Ee as default
};
